<script>
export let quantity
export let etype
</script>

<div class="radio-container">
<p><b>Time of day</b></p>
<label>
	<input type=radio bind:group={quantity} name="layer" value={'_overall'} checked>
	Entire day
</label>
<label>
	<input type=radio bind:group={quantity} name="layer2" value={'_07:30-09:30_school'} >
	School dropoff (07:30-09:30)
</label>
<label>
	<input type=radio bind:group={quantity} name="layer3" value={'_13:00-15:10_school'} >
	School collection (13:00-15:10)
</label>

</div>


<div class="radio-container-2">
	<p><b>Pollutant</b></p>
	<label>
		<input type=radio bind:group={etype} name="layer4" value={'NO2'} checked>
		NO2
	</label>
	<label>
		<input type=radio bind:group={etype} name="layer5" value={'PM25'} >
		PM25 
	</label>

	
	</div>


<style>
	.radio-container {
		position: fixed;
		bottom: 80px;
		left: 13px;
		background-color:#4d5061;
		padding: 4px;
		color: white;
		border: 0px solid white;
		border-radius: 5px;
		font-size:.8em;
	}

	.radio-container-2 {
		position: fixed;
		bottom: 200px;
		left: 13px;
		background-color:#4d5061;
		padding: 4px;
		color: white;
		border: 0px solid white;
		border-radius: 5px;
		font-size:.8em;
	}

	p{
		padding-top:0px;
		font-size:1.2em;
	}
</style>